// import OrderConfirmationPage from './OrderConfirmationPage';
import { isComponentFor } from 'Shared/resolve-component';
export default (currentPage) => {
    return isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Checkout.Pages.OrderConfirmation.OrderConfirmationPageViewModel");
};
